module.exports = __webpack_public_path__ + "static/media/kyc_complete_setup.da50aabe.svg";